import { useEffect, useState } from 'react'
import {
  VStack,
  Text,
  Heading,
  Stack,
  Button,
  FormControl,
  Input,
  Box,
  Image,
  useMediaQuery,
  Flex
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowBackIcon } from '@chakra-ui/icons'

import clientAxios from '../../config/axios'
import useAuth from '../../hooks/useAuth'
import SessionStartLogo from '../../components/SessionStartLogo'

const quilmesImages = require.context('../../assets/images', true)

function LoginInvited () {
  const { user, login, loginWithGoogle } = useAuth()
  const [error, setError] = useState('')
  const [errorName, setErrorName] = useState('')
  const [errorLastName, setErrorLastName] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [errorMailQuilmes, setErrorMailQuilmes] = useState('')
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [isLargerThan1280] = useMediaQuery('(min-width: 1367px)')
  const navigate = useNavigate()
  const [userState, setUserState] = useState({
    id: '',
    name: '',
    lastname: '',
    email: ''
  })

  const [userBackend, setUserBackend] = useState({
    name: '',
    surname: '',
    mail: ''
  })
  const { setUserInvited, setUserRegister } = useAuth()

  /* Checking if there is a user, survey or products in the sessionStorage. If there is, it removes
  them. */
  useEffect(() => {
    const user = sessionStorage.getItem('user')
    const survey = sessionStorage.getItem('object')
    const products = sessionStorage.getItem('products')
    const geoArea = sessionStorage.getItem('geoArea')
    const geoAreaSelected = sessionStorage.getItem('geoAreaSelected')
    const bottler = sessionStorage.getItem('bottler')
    const bottlerSelected = sessionStorage.getItem('bottlerSelected')

    if (user || survey || products || geoArea || geoAreaSelected || bottler || bottlerSelected) {
      sessionStorage.removeItem('user')
      sessionStorage.removeItem('object')
      sessionStorage.removeItem('products')
      sessionStorage.removeItem('geoArea')
      sessionStorage.removeItem('geoAreaSelected')
      sessionStorage.removeItem('bottler')
      sessionStorage.removeItem('bottlerSelected')
    }
  }, [])

  /**
   * It takes the name and value of the input and sets the state of the user with the new value
   * @param e - the event that is triggered when the input is changed
   */
  const handleChange = (e) => {
    const { name, value } = e.target

    if (name === 'name') {
      setUserState({
        ...userState,
        name: value
      })

      setUserBackend({
        ...userBackend,
        name: value
      })
    } else if (name === 'lastname') {
      setUserState({
        ...userState,
        lastname: value
      })

      setUserBackend({
        ...userBackend,
        surname: value
      })
    } else {
      setUserState({
        ...userState,
        email: value
      })

      setUserBackend({
        ...userBackend,
        mail: value
      })
    }
  }

  const handleGoogleSignin = async () => {
    try {
      const user = await loginWithGoogle()

      clientAxios.post('/auth/login', { idToken: user.user.accessToken, providerType: 2 })
        .then((res) => {
          if (res.status === 200) {
            setUserRegister(res.data)
            sessionStorage.setItem('user', JSON.stringify(res.data))
            navigate('/survey-information')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (error) {
      setError(error.message)
    }
  }

  /**
   * It handles the form submission and validates the input fields
   * @param e - The event object
   * @returns the form with the inputs and the button to submit the form.
   */
  const handleSubmit = (e) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/
    const regexEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/
    const nameSpace = /^\S.*\S$/

    e.preventDefault()

    if (
      userState.name === '' &&
      userState.lastname === '' &&
      userState.email === ''
    ) {
      setError('Todos los campos son obligatorios')

      setTimeout(() => {
        setError('')
      }, 3000)

      return
    }

    if (userState.name === '') {
      setErrorName('El nombre es obligatorio')

      return
    } else if (!regex.test(userState.name)) {
      setErrorName('El nombre solo puede contener letras')

      return
    } else if (!nameSpace.test(userState.name)) {
      setErrorName('No se permiten espacios al inicio y al final.')

      return
    } else {
      setErrorName('')
    }

    if (userState.lastname === '') {
      setErrorLastName('El apellido es obligatorio')

      return
    } else if (!regex.test(userState.lastname)) {
      setErrorLastName('El apellido solo puede contener letras')

      return
    } else if (!nameSpace.test(userState.lastname)) {
      setErrorLastName('No se permiten espacios al inicio y al final.')

      return
    } else {
      setErrorLastName('')
    }

    if (userState.email === '') {
      setErrorEmail('El email es obligatorio')

      return
    } else if (!regexEmail.test(userState.email)) {
      setErrorEmail('El email no es válido')

      return
    } else {
      setErrorEmail('')
    }

    clientAxios
      .post('/user/guest', userBackend, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        setUserRegister(response.data)
        sessionStorage.setItem('user', JSON.stringify(response.data))
        navigate('/survey-information')
      })
      .catch((error) => {
        if (error.response.status === 401) {
          if (error.response.data.message === 'Existe una cuenta registrada con el mail ingresado.') {
            setErrorEmail('Ya existe una cuenta registrada con este correo electrónico. Ingresá iniciando sesión.')
            setTimeout(() => {
              setErrorEmail('')
            }, 3800)

            return
          }
          if (error.response.data.message === 'Mail reservado para usuarios registrados.') {
            setErrorEmail(error.response.data.message)

            setTimeout(() => {
              setErrorEmail('')
            }, 3800)
          }
        }
      })

    setError('')

    setTimeout(() => {
      setUserState({
        id: '',
        name: '',
        lastname: '',
        email: ''
      })
    }, 4000)
  }

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' mx={'auto'}>
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}
          {...(isLargerThan1280
            ? { paddingTop: '12rem' }
            : isLargerThan768
              ? { paddingTop: '3rem' }
              : {})}
        >
          <SessionStartLogo />
          <Link to={'/'}>
            <ArrowBackIcon color={'#0A0808'} h={6} marginTop={{ base: 6, md: 4 }} w={6} />
          </Link>
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'.5rem'}>
            Ingresar como invitado
          </Heading>
          <Text fontSize={'0.8rem'} fontWeight={'400'}>
            Por favor ingrese los siguientes datos.
          </Text>

          <Stack paddingTop={'2rem'} w={{ base: '100%', md: 400 }}>
            <FormControl className='floating-label-group'>
              <Input
                autoComplete='new-text'
                className='input'
                id='name'
                name='name'
                placeholder=' '
                type='text'
                value={userState.name}
                onChange={handleChange}
                onFocus={() => setErrorName('')}
                {...(error !== ''
                  ? { borderColor: 'red.500', _hover: 'red.500' }
                  : errorName !== ''
                    ? { borderColor: 'red.500', _hover: 'red.500' }
                    : {})}
              />
              <label
                className='placeholder'
                htmlFor='name'
                {...(error
                  ? { className: 'error-input' }
                  : errorName
                    ? { className: 'error-input' }
                    : {})}
              >
                Nombre *
              </label>
            </FormControl>
            {errorName && (
              <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
                {errorName}
              </Text>
            )}

            <FormControl className='floating-label-group'>
              <Input
                autoComplete='new-text'
                className='input'
                id='lastname'
                name='lastname'
                placeholder=' '
                type='text'
                value={userState.lastname}
                onChange={handleChange}
                onFocus={() => setErrorLastName('')}
                {...(error !== ''
                  ? { borderColor: 'red.500', _hover: 'red.500' }
                  : errorLastName !== ''
                    ? { borderColor: 'red.500', _hover: 'red.500' }
                    : {})}
              />
              <label
                className='placeholder'
                htmlFor='lastname'
                {...(error
                  ? { className: 'error-input' }
                  : errorLastName
                    ? { className: 'error-input' }
                    : {})}
              >
                Apellido *
              </label>
            </FormControl>
            {errorLastName && (
              <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
                {errorLastName}
              </Text>
            )}

            <FormControl className='floating-label-group'>
              <Input
                className='input'
                id='email'
                name='email'
                placeholder=' '
                type='text'
                value={userState.email}
                onChange={handleChange}
                onFocus={() => setErrorEmail('')}
                {...(error !== ''
                  ? { borderColor: 'red.500', _hover: 'red.500' }
                  : errorEmail !== ''
                    ? { borderColor: 'red.500', _hover: 'red.500' }
                    : {})}
              />
              <label
                className='placeholder'
                htmlFor='email'
                {...(error
                  ? { className: 'error-input' }
                  : errorEmail
                    ? { className: 'error-input' }
                    : {})}
              >
                Correo electrónico *
              </label>
            </FormControl>
            {errorEmail && (
              <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
                {errorEmail}
              </Text>
            )}

            {errorMailQuilmes && (
              <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
                {errorMailQuilmes}
              </Text>
            )}
          </Stack>

          {error && (
            <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
              Todos los campos son obligatorios
            </Text>
          )}

          <Stack
            justifyContent='center'
            paddingTop={3}
            w={{ base: '100%', md: 400 }}
          >
            <Button
              _focusVisible={{ outline: 'none' }}
              type='submit'
              variant={'btn-quilmes'}
            >
              Iniciar Relevamiento
            </Button>
          </Stack>
        </VStack>

        <Box textAlign={'center'}>
          <Text
            color={'#0A0808'}
            fontSize={'14px'}
          >Iniciar sesión con Google</Text>
          <Flex gap={4} justifyContent={'center'}>
            <Button
              _active={{ background: 'none' }}
              _hover={{ background: 'none' }}
              bg={'#FFF'}
              borderRadius={'50%'}
              h={'3rem'}
              marginTop={4}
              padding={0}
              w={'3rem'}
              onClick={handleGoogleSignin}
            >
              <Image
                alt='Google'
                objectFit={'cover'}
                src={quilmesImages('./google.svg')}
              />
            </Button>
            <Box display={'none'}>
              <Button
                _active={{ background: 'none' }}
                _hover={{ background: 'none' }}
                bg={'#FFF'}
                borderRadius={'50%'}
                h={'3rem'}
                marginTop={4}
                padding={0}
                w={'3rem'}
              >
                <Image
                  alt='Microsoft'
                  height={'3rem'}
                  src={quilmesImages('./microsoft.svg')}
                  width={'3rem'}
                />
              </Button>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default LoginInvited
